<template>
<div>
    <v-card flat color="transparent" class="mt-7">
        <v-toolbar  class="bdr secondary2light" :elevation="0" outlined>
            <v-toolbar-title>{{$t('animal.reminders')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn
                disabled
                icon
                large
            >
                <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn
                icon
                large
                disabled
            >
                <v-icon>mdi-cog-outline</v-icon>
            </v-btn> -->
            <v-btn
               color="primary"
               @click="$router.push({
                name: 'CreateTask',
                params: {
                    animal: $route.params.animal_number
                }
               })" 
            >
                Add Task
            </v-btn>
        </v-toolbar>
    </v-card>
    <v-card flat class="mt-7" min-height="600">
        <v-card-text>
            <reminders/>
        </v-card-text>
    </v-card>
</div>
</template>
<script>
import Reminders from './reminders/Reminders.vue'

export default {
    components: {
        Reminders,
    },
    created() {
        const fetchData = async () => {
        }
        fetchData();
    },
    data() {
        return {
            tab: null,
        }
    },

    methods: { }
}
</script>
<style lang="scss" scoped>
.bdr {
    border: thin solid $secondary-color;
}
</style>